/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Orders_In_TripInputs */

const vi_trip_orders_in_trip = /** @type {(inputs: Trip_Orders_In_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn trong chuyến`)
};

/**

* @param {Trip_Orders_In_TripInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_orders_in_trip = /** @type {((inputs?: Trip_Orders_In_TripInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Orders_In_TripInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_orders_in_trip(inputs)
});